<section
  fxLayout="column"
  fxLayoutAlign="start stretch"
  fxLayoutGap="16px">
  <mg-tools-actions-header
    *ngIf="person$ | async; else headerLoaderTemplate"
    [person]="person$ | async"
    [onOwnProfile]="true">
    <ng-container *ngIf="favoriteActions$ | async as favoriteActions">
      <ng-container *ngFor="let action of favoriteActions">
        <mg-btn
          *ngIf="action.hasPermission$ | async"
          variant="outlined"
          iconSet="minga"
          [icon]="action.icon"
          [iconColor]="$any(action.iconColor)"
          [id]="'tools-dashboard-click-' + action.key"
          (pressed)="action.onPress()">
          {{ action.label }}
        </mg-btn>
      </ng-container>
    </ng-container>
    <mg-tools-actions-button *ngIf="hasAssignActions$ | async"></mg-tools-actions-button>
  </mg-tools-actions-header>

  <ng-container *ngIf="isScheduleEnabled$ | async">
    <mg-student-schedule-widget
      [showHomeroom]="hasHomeroom$ | async"
      [bellScheduleEnabledForCurrentUser]="isBellScheduleEnabledForCurrentUser$ | async"
      [scheduleItems]="scheduleItems$ | async"
      (viewAllPressed)="goToSchedule()"
      (scheduleItemPressed)="openMyClassWithScheduleItem($event)"
      (homeroomPressed)="openMyClassWithHomeroom()">
    </mg-student-schedule-widget>
  </ng-container>

  <div class="stickers-groups">
    <mg-tools-stickers [personHash]="(person$ | async)?.hash"> </mg-tools-stickers>
    <mg-tools-groups
      *ngIf="isGroupsEnabled$ | async"
      [personHash]="(person$ | async)?.hash">
    </mg-tools-groups>
  </div>
</section>

<!-- Header Loader Template -->
<ng-template #headerLoaderTemplate>
  <mg-placeholder-card>
    <div class="tw-grid tw-gap-2.5">
      <div class="tw-flex tw-flex-row tw-gap-2 tw-items-center">
        <mg-placeholder-avatar size="medium"></mg-placeholder-avatar>
        <mg-placeholder-header
          class="tw-w-2/3"
          size="medium"></mg-placeholder-header>
      </div>
      <mg-placeholder-button class="tw-w-1/3"></mg-placeholder-button>
    </div>
  </mg-placeholder-card>
</ng-template>
